
<template>
  <div class="w1200 newsBox">
    <div class="leftBox">
      <div class="crumbs">
        <span class="el-icon-location" /><span class="sname">专题</span><span>/{{ IinitData.specialDetail.specialName }}</span>
      </div>
      <div class="imgBox">
        <img :src="IinitData.specialDetail.specialCover" alt="">
        <p class="names">
          {{ IinitData.specialDetail.specialName }}
        </p>
        <p class="times">
          {{ IinitData.specialDetail.createDate |changeTime2 }}
        </p>
      </div>
      <div class="specialAbstract_box">
        <div v-if="IinitData.specialDetail.specialAbstract" class="specialAbstract">
          {{ IinitData.specialDetail.specialAbstract }}
        </div>
      </div>
      <div class="fenlei">
        <div class="columnBoxInnner">
          <div class="columnBoxInnnerList">
            <div v-for="(item,index) in arrs" :key="index" :class="currrentindex==index?'activename':'column_a'" @click="changeNowColumn(item.value,index)">
              <span class="nameshow">{{ item.name }}</span><span v-show="index<arrs.length-1" class="a_span">/</span>
            </div>
          </div>
        </div>
        <!--<div>{{columnlist}}</div>-->
        <!-- 内容列表 -->
        <Centerlisthome :columnlist="currentData" />
        <div v-if="loadAll" class="atfoot loadMore">
          已经到底部了
        </div>
        <div v-else class="loadMore" @click="addMore">
          加载更多>>
        </div>
      </div>
    </div>
    <div class="rightBox">
      <Rightlist />
    </div>
  </div>
</template>
<script>
import Rightlist from '@/components/commonRightList'
import Centerlisthome from '@/components/centerlist_specTopic_detial/index.vue'
import { getstdcontentData, addReadSize_special } from '@/api/api.js'
import { ssoUserLogin } from '@/api/api.js'
export default {
  components: { Rightlist, Centerlisthome },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: this.IinitData.specialDetail.specialName + '-彭祖世家网_寻根问祖_家谱百科_家谱制作领导者',
      mateDesc: metaStr,
      keys: this.IinitData.specialDetail.specialTag
    }
  },
  data() {
    return {
      currrentindex: 0,
      loadAll: false,
      arrs: [{ name: '全部', value: 'quanbu' }, { name: '资讯', value: 'NEWS' }, { name: '图集', value: 'PHOTO' }, { name: '视频', value: 'VIDEO' }, { name: '文库', value: 'DOC' }],
      currentData: '',
      currentPage: 1,
      page: 1,
      currentType: 'quanbu'
    }
  },
  computed: {
    IinitData() {
      return this.$store.state.StdData
    }
  },
  asyncData({ store, route }) {
    return store.dispatch('getStdData', { 'specialId': route.query.contentId, 'index': '1', 'size': '9' })
  },
  updated() {
    // console.log(this.IinitData)
  },
  mounted() {
    ssoUserLogin().then(res => {
      if (res.data.userId) {
        this.setloca('userid', res.data.userId, 7200)
        localStorage.removeItem('unionid')
      } else {
        localStorage.removeItem('userid')
      }
    })
    this.fn()
    if (this.IinitData.specialContent) {
      this.currentData = this.IinitData.specialContent.listMapData
    }
    if (this.IinitData.specialContent.page <= 1) {
      this.loadAll = true
    }
    if (this.$route.query.contentId) {
      addReadSize_special({ specialId: this.$route.query.contentId }).then(res => {

      })
    }
  },

  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    changeNowColumn: function(type, index) {
      this.currentType = type
      var obj = {}
      obj.index = '1'
      obj.size = '15'
      obj.specialId = this.$route.query.contentId
      this.currrentindex = index
      if (type !== 'quanbu') {
        obj.templateId = type
        getstdcontentData(obj).then(res => {
          this.page = res.data.page
          this.currentPage = 1
          this.currentData = res.data.listMapData
          if (this.currentPage == this.page) {
            this.loadAll = true
          }
        })
      } else {
        getstdcontentData(obj).then(res => {
          this.page = res.data.page
          this.currentPage = 1
          this.currentData = res.data.listMapData
          if (this.currentPage == this.page) {
            this.loadAll = true
          }
        })
      }
    },
    addMore: function() {
      this.currentPage = this.currentPage * 1 + ''
      var obj = {}
      obj.index = '1'
      obj.size = this.currentPage
      obj.specialId = this.$route.query.contentId
      if (this.currentType !== 'quanbu') {
        obj.templateId = this.currentType
        getstdcontentData(obj).then(res => {
          this.currentData = res.data.listMapData
        })
      } else {
        getstdcontentData(obj).then(res => {
          this.currentData = res.data.listMapData
        })
      }
      if (this.currentPage == this.page) {
        this.loadAll = true
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .columnBoxInnner{
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: #fff;
  }
  .sname{
    color: #ed4040;
  }
  .atfoot{
    cursor: auto;
  }
  .loadMore{
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #999999;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    cursor: pointer;
    display: inline-block;
    width: 878px;
    transition: 0.5s;
    margin-bottom: 50px;
    text-align: center;
    margin-top: 20px;
    &:hover{
      color: #ed4040;
      border: 1px solid #ed4040;
    }
  }
  .newsBox{
    background-color: #fafafa;
    overflow: hidden;
    position: relative;
  }
  .leftBox{
    width: 880px;
    margin-right: 20px;
    margin-top: 20px;
    float: left;
    .crumbs{
      height: 40px;
      line-height: 40px;
      border: 1px solid #e5e5e5;
      padding-left: 10px;
      color: #808080;
      background-color: #fff;
      margin-bottom: 20px;
    }
    .imgBox{
      margin-top: 20px;
      height: 340px;
      background-color: #fff;
      position: relative;
      overflow: hidden;
      img{
        height: 340px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -webkit-filter : blur(3px);
        filter : blur(3px);
      }
      p{
        position: absolute;
        text-align: center;
        width: 100%;
        color:#ffffff;
      }
      .names{
        height: 40px;
        line-height: 40px;
        top: 130px;
        font-size: 28px;
      }
      .times{
        top: 170px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
      }
    }
    .specialAbstract_box{
      background-color: #fff;
      overflow: hidden;
      margin-top: 10px;
      padding: 10px 20px;
      .specialAbstract{
        background-color: #fafafa;
        overflow: hidden;
        padding: 10px 0;
        font-size: 12px;
        color: #4d4d4d;
      }
}
    .fenlei{
      overflow: hidden;
      text-align: center;
      padding-top: 20px;
      .column_a{
        display: inline-block;
        cursor: pointer;
        font-size: 16px;
        .a_span{
          margin: 0 16px;
        }
        .nameshow{
          font-size: 16px;
          color: #333333;
          font-weight: 600;
          &:hover{
            color: #ed4040;
          }
        }
      }
      .activename{
        display: inline-block;
        cursor: pointer;
        .a_span{
          margin: 0 16px;
        }
        .nameshow{
          color: #ed4040;
          font-size: 16px;
          font-weight: 600;
        }

      }
    }

  }
  .rightBox{
    width: 300px;
    /*margin-left: 20px;*/
    margin-top: 20px;
    float: right;
    /*top: 0;*/
    /*right: 0;*/
    overflow: hidden;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .leftBox{
      width: 100%;
      margin-top: 0;
      .bannerBox{
        width: 100%;
        height: auto;
      }
      .imgBox{
        height: 160px;
        img{
          height: 160px;
        }
        .names{
          top: 60px;
          font-size: 26px;
        }
        .times{
          top: 120px;
        }
      }
    }
    .rightBox{
      display: none;
    }
    .columnlistBox{
      margin-top: 0;
    }
    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      padding-bottom: 20px;
      overflow-x: auto;
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
    }
    .loadMore{
      width: 100%;
    }
  }
</style>
